import { render } from "./MyQR.vue?vue&type=template&id=1816efb6&scoped=true"
import script from "./MyQR.vue?vue&type=script&lang=js"
export * from "./MyQR.vue?vue&type=script&lang=js"

import "./MyQR.vue?vue&type=style&index=0&id=1816efb6&scoped=true&lang=stylus"

import exportComponent from "D:\\zhongzhi\\wuzangceping_sahngyeban\\health-WeChat-small-program-page\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1816efb6"]])

export default __exports__